export const InventoryListColConfig = [
  {
    name_of_db_column: 'productId',
    label_of_column: 'PRODUCT ID',
    order_of_column: 1,
    columnFilterPlaceholder: 'Product ID',
  },
  {
    name_of_db_column: 'warehouseId',
    label_of_column: 'WAREHOUSE ID',
    order_of_column: 2,
    columnFilterPlaceholder: 'Warehouse ID',
  },
  {
    name_of_db_column: 'gtin',
    label_of_column: 'GTIN',
    order_of_column: 3,
    columnFilterPlaceholder: 'GTIN',
  },
  {
    name_of_db_column: 'parentId',
    label_of_column: 'PARENT ID',
    order_of_column: 4,
    columnFilterPlaceholder: 'Parent ID',
  },
  {
    name_of_db_column: 'stock',
    label_of_column: 'STOCK',
    order_of_column: 5,
    columnFilterPlaceholder: 'Stock',
  },
  {
    name_of_db_column: 'daysOnStock',
    label_of_column: 'DAYS ON STOCK',
    order_of_column: 6,
    columnFilterPlaceholder: 'Days On Stock',
    filterVariant: 'double',
  },
  {
    name_of_db_column: 'lastUpdated',
    label_of_column: 'LAST UPDATED',
    order_of_column: 8,
    filterVariant: 'date',
    initialSize: 330,
    columnFilterPlaceholder: 'Last Updated',
  },
]
